import { useTranslation } from "react-i18next";
import { Button, Icon } from "semantic-ui-react";

import CarRepair from "assets/img/car-repair.png";
import LicenseIcon from "assets/svg/500-license-plate.svg";
import { Logo } from "components";
import "components/ErrorFallback/ErrorFallback.scss";
import { useRedirectToLandingPage } from "modules/Login/hooks";

type ErrorFallbackProps = {
  error: Error;
  resetErrorBoundary: () => void;
};

export const ErrorFallback = ({ resetErrorBoundary }: ErrorFallbackProps) => {
  const { t } = useTranslation();

  const redirectToLandingPage = useRedirectToLandingPage();

  return (
    <div className="ErrorFallback">
      <div className="ErrorFallback-overlay">
        <div className="ErrorFallback-container">
          <div className="ErrorFallback-logo">
            <Logo />
          </div>
          <div className="ErrorFallback-action-buttons">
            <Button icon labelPosition="left" onClick={() => redirectToLandingPage}>
              <Icon className="arrow left" />
              {t("v8_back_to_homepage", "Back to Homepage")}
            </Button>
            <Button className="light" onClick={resetErrorBoundary}>
              {t("v8_reload_page", "Reload page")}
            </Button>
          </div>
          <div className="NotFoundPage-car-repair">
            <img src={CarRepair} />
            <div className="NotFoundPage-svg-icon">
              <img src={LicenseIcon} />
            </div>
            <div className="NotFoundPage-error-text">{t("v8_internal_server_error", "Internal Server Error")}</div>
          </div>
        </div>
      </div>
    </div>
  );
};
